<template>
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Site ID</th>
          <!-- <th>Site Name</th> -->
          <th>Open Queries</th>
          <th>Critical Queries</th>
          <th>Avg. Age (days)</th>
          <!-- <th>Action</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="site in sites" :key="site.id">
          <td>{{ site.id }}</td>
          <!-- <td>{{ site.name }}</td> -->
          <td>
            <span class="badge" :class="badgeClass(site)">
              {{ site.openQueries }}
            </span>
          </td>
          <td>{{ site.criticalQueries }}</td>
          <td>{{ site.avgAge }}</td>
          <!-- <td>
            <button class="btn btn-sm btn-outline-primary">View Details</button>
          </td> -->
        </tr>
      </tbody>
    </table>
  </template>
  
  <script>
  export default {
    name: 'ProblematicSitesTable',
    props: {
      sites: {
        type: Array,
        required: true
      }
    },
    methods: {
      badgeClass(site) {
        return {
          'badge-danger': site.openQueries > 15,
          'badge-warning': site.openQueries > 10 && site.openQueries <= 15
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .badge {
    font-size: 0.9rem;
    padding: 5px 10px;
  }
  
  .badge-danger {
    background-color: #dc3545;
    color: white;
  }
  
  .badge-warning {
    background-color: #ffc107;
    color: #212529;
  }
  </style>